import "./bookingLoaders.css";

/** The word "Loading" with three dots ticking in after it. */
function BookShipmentLoadingText() {
  return <span className="loading-text-loader">Loading</span>;
}

export default BookShipmentLoadingText;
